// utils/IconMapper.js
import React from 'react';

// IMPORT SOLO LOS ICONOS QUE REALMENTE NECESITAS
import LaptopWindows from '@mui/icons-material/LaptopWindows';
import SupervisedUserCircle from '@mui/icons-material/SupervisedUserCircle';
import Psychology from '@mui/icons-material/Psychology';
import Person from '@mui/icons-material/Person';
import People from '@mui/icons-material/People';
import CreditCard from '@mui/icons-material/CreditCard';
import Description from '@mui/icons-material/Description';
import Business from '@mui/icons-material/Business';
import LocalShipping from '@mui/icons-material/LocalShipping';
import Folder from '@mui/icons-material/Folder';
import Info from '@mui/icons-material/Info';
import LocationOn from '@mui/icons-material/LocationOn';
import Route from '@mui/icons-material/Route';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import History from '@mui/icons-material/History';
import PersonOutline from '@mui/icons-material/PersonOutline';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import GpsFixed from '@mui/icons-material/GpsFixed';
import Flight from '@mui/icons-material/Flight';
import Storefront from '@mui/icons-material/Storefront';
import AttachMoney from '@mui/icons-material/AttachMoney';
import Receipt from '@mui/icons-material/Receipt';
import Category from '@mui/icons-material/Category';
import Assessment from '@mui/icons-material/Assessment';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import FlightTakeoff from '@mui/icons-material/FlightTakeoff';
import Construction from '@mui/icons-material/Construction';
import Build from '@mui/icons-material/Build'; 
import Handyman from '@mui/icons-material/Handyman';
import Settings from '@mui/icons-material/Settings';
import Report from '@mui/icons-material/Report';
import BuildCircle from '@mui/icons-material/BuildCircle';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import ListAlt from '@mui/icons-material/ListAlt';
import Assignment from '@mui/icons-material/Assignment';
import LocalTaxi from '@mui/icons-material/LocalTaxi';

// Iconos base del sistema
import Dashboard from '@mui/icons-material/Dashboard';
import ExitToApp from '@mui/icons-material/ExitToApp';
import Menu from '@mui/icons-material/Menu';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// Mapeo de nombres a componentes (solo los que usas)
const iconMap = {
  // Iconos de administración
  LaptopWindows,
  SupervisedUserCircle,
  Psychology,
  Person,
  People,
  Card: CreditCard,
  Documents: Description,
  Proyects: Business,
  Manifiest: LocalShipping,
  proyectDocuments: Folder,
  Detail: Info,
  Localizaciones: LocationOn,
  Rutas: Route,
  ProyectEmployees: PeopleOutline,
  VehiculosProject: DirectionsCar,
  Historial: History,
  EmpleadoDetail: PersonOutline,
  VehiculoDetalle: DirectionsCar,
  CalendarioMolissa: CalendarMonth,
  Organizacionesproveedoras: Business,
  MonitorViajeIco: GpsFixed,
  ManifiestosInternosIco: LocalShipping,
  ManifiestosExternosIco: Flight,
  Organizations: Storefront,
  ValorizacionesIco: AttachMoney,
  ValorizacionDetalleIco: Receipt,
  TiposServiciosProyectoIco: Category,
  ReportesOrdenServicioIco: Assessment,
  ClienteOrdenServicioIco: ShoppingCart,
  
  // Iconos de cliente
  ViajesClientePageIcon: FlightTakeoff,
  ViajesClienteDetailPageIcon: Receipt,
  
  // Iconos de mantenimiento
  MantenimientoDetalleIco: Construction,
  ComponentesVehiculoIco: Build,
  MantenimientosComponenteIco: Handyman,
  SistemasVehiculoIco: Settings,
  MantenimientosVehiculoIco: DirectionsCar,
  MantenimientosVehiculoDetalleIco: Report,
  TiposComponenteIco: Category,
  TiposMantenimientoIco: BuildCircle,
  
  // Iconos de contabilidad
  TiposComprobanteIco: ReceiptLong,
  
  // Iconos de administración de servicios
  TiposServiciosIco: ListAlt,
  TaxiTiposServiciosIco: LocalTaxi,
  OrdenesServiciosIco: Assignment,
  ServicioDetalleIco: Info,
  ServicioHistorialIco: History,
  
  // Iconos base del sistema
  Dashboard,
  ExitToApp,
  Menu,
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore
};

// Función para obtener el icono basado en el nombre de la BD
export const getIconByName = (iconName) => {
  if (!iconName) return Dashboard;
  
  // Mapear nombres específicos de tu BD
  const nameMapping = {
    'LaptopWindows': 'LaptopWindows',
    'SupervisedUserCircle': 'SupervisedUserCircle',
    'Psychology': 'Psychology',
    'Person': 'Person',
    'Usser': 'People',
    'Card': 'Card',
    'Documents': 'Documents',
    'Proyects': 'Proyects',
    'Manifiest': 'Manifiest',
    'proyectDocuments': 'proyectDocuments',
    'Detail': 'Detail',
    'Localizaciones': 'Localizaciones',
    'Rutas': 'Rutas',
    'ProyectEmployees': 'ProyectEmployees',
    'VehiculosProject': 'VehiculosProject',
    'Historial': 'Historial',
    'EmpleadoDetail': 'EmpleadoDetail',
    'Organizaciones proveedoras': 'Organizacionesproveedoras',
    'Calendario Molissa': 'CalendarioMolissa',
    'VehiculoDetalle': 'VehiculoDetalle',
    'MonitorViajeIco': 'MonitorViajeIco',
    'ManifiestosInternosIco': 'ManifiestosInternosIco',
    'ManifiestosExternosIco': 'ManifiestosExternosIco',
    'Organizations': 'Organizations',
    'ValorizacionesIco': 'ValorizacionesIco',
    'ValorizacionDetalleIco': 'ValorizacionDetalleIco',
    'TiposServiciosProyectoIco': 'TiposServiciosProyectoIco',
    'ReportesOrdenServicioIco': 'ReportesOrdenServicioIco',
    'ClienteOrdenServicioIco': 'ClienteOrdenServicioIco',
    'ViajesClientePageIcon': 'ViajesClientePageIcon',
    'ViajesClienteDetailPageIcon': 'ViajesClienteDetailPageIcon',
    'MantenimientoDetalleIco': 'MantenimientoDetalleIco',
    'ComponentesVehiculoIco': 'ComponentesVehiculoIco',
    'MantenimientosComponenteIco': 'MantenimientosComponenteIco',
    'TiposComponenteIco': 'TiposComponenteIco',
    'TiposMantenimientoIco': 'TiposMantenimientoIco',
    'TiposComprobanteIco': 'TiposComprobanteIco',
    'TiposServiciosIco': 'TiposServiciosIco',
    'TaxiTiposServiciosIco': 'TaxiTiposServiciosIco',
    'OrdenesServiciosIco': 'OrdenesServiciosIco',
    'ServicioDetalleIco': 'ServicioDetalleIco',
    'ServicioHistorialIco': 'ServicioHistorialIco',
    'SistemasVehiculoIco': 'SistemasVehiculoIco',
    'MantenimientosVehiculoIco': 'MantenimientosVehiculoIco',
    'MantenimientosVehiculoDetalleIco': 'MantenimientosVehiculoDetalleIco',
  };
  
  const mappedName = nameMapping[iconName] || iconName;
  const IconComponent = iconMap[mappedName] || Dashboard;
  
  return IconComponent;
};

// Componente para renderizar el icono directamente
export const DynamicIcon = ({ iconName, sx, ...props }) => {
  const IconComponent = getIconByName(iconName);
  return <IconComponent sx={sx} {...props} />;
};

export default iconMap;